"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RED_FLAG_LEVELS = void 0;
exports.RED_FLAG_LEVELS = {
    active: { short: 'A', long: 'Active' },
    not_active: { short: 'NA', long: 'Not Active' },
};
